import { NgModule, inject } from '@angular/core';
import { CcoEntityUrlRegistryService } from '@app/data/cco-entity-url-registry.service';
import { entityUrlMap } from '@app/store/entity-metadata';

@NgModule({})
export class CcoEntityUrlRegistryModule {
  constructor() {
    const entityUrlRegistry = inject(CcoEntityUrlRegistryService);

    entityUrlRegistry.registerEntityUrls(entityUrlMap);
  }
}
